import { Injectable } from '@angular/core'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { CartPageLayoutHandler } from '@spartacus/cart/base/components'
import { CartConfigService, SelectiveCartService } from '@spartacus/cart/base/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import {FeaturedProductService} from '../product/services/featured-product.service';

@Injectable({
  providedIn: 'root',
})
export class MbCartPageLayoutHandler extends CartPageLayoutHandler {
  constructor (protected activeCartService: ActiveCartFacade,
               protected selectiveCartService: SelectiveCartService,
               protected cartConfig: CartConfigService,
               private featuredProductService: FeaturedProductService
               ) {
    super(activeCartService, selectiveCartService, cartConfig)
  }

  handle (
    slots$: Observable<string[]>,
    pageTemplate?: string,
    section?: string
  ) {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      return combineLatest([
        slots$,
        this.activeCartService.getActive(),
        this.getSelectiveCart(),
        this.activeCartService.getLoading(),
        this.featuredProductService.getProducts()
      ]).pipe(
        map(([slots, cart, selectiveCart, loadingCart, featuredProducts]) => {
          const exclude = (arr: any[], args: any[]) =>
            arr.filter((item: any) => args.every((arg: any) => arg !== item))
          if(featuredProducts.length === 0) {
            slots = exclude(slots, ['BottomContent'])
          }
          return Object.keys(cart).length === 0 && loadingCart
            ? exclude(slots, [
              'TopContent',
              'CenterRightContentSlot',
              'CenterRightContentSlotEU',
              'CenterRightContentSlotUS',
              'EmptyCartMiddleContent',
            ])
            : cart.totalItems
              ? exclude(slots, ['EmptyCartMiddleContent'])
              : selectiveCart?.totalItems
                ? exclude(slots, [
                  'EmptyCartMiddleContent',
                  'CenterRightContentSlot',
                  'CenterRightContentSlotEU',
                  'CenterRightContentSlotUS',
                ])
                : exclude(slots, ['TopContent', 'Footer'])
        })
      )
    }
    return slots$
  }
}
